import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_APP_AUTHENTICATION]: state => state.authentication,
};

const actions = {};

const mutations = {
  [mutationTypes.SET_APP_AUTHENTICATION](state, authentication) {
    state.authentication = authentication;
  },
};

export default {
  state: {
    authentication: null,
  },
  getters,
  actions,
  mutations,
};
